// Tiny wrapper around localStorage with TTL + timestamp metadata.
// Used by the Dashboard to show last-known-good data during cold-starts
// and API timeouts instead of a blank "Unable to load" banner.

const NS = "capital360:v1:";

export function cacheSet(key, value) {
  try {
    localStorage.setItem(
      NS + key,
      JSON.stringify({ value, savedAt: Date.now() }),
    );
  } catch {
    // Quota exceeded / private mode — silent no-op
  }
}

export function cacheGet(key) {
  try {
    const raw = localStorage.getItem(NS + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.savedAt !== "number") return null;
    return parsed; // { value, savedAt }
  } catch {
    return null;
  }
}

export function cacheClear(key) {
  try {
    localStorage.removeItem(NS + key);
  } catch {
    // noop
  }
}

export function cacheClearAll() {
  try {
    const keys = Object.keys(localStorage).filter(k => k.startsWith(NS));
    keys.forEach(k => localStorage.removeItem(k));
  } catch {
    // noop
  }
}

export function timeAgo(ts) {
  if (!ts) return "";
  const diff = Math.max(0, Date.now() - ts);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
